import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import PlaceholderWrapper from "../Common/PlaceholderWrapper";
import ComplexParam from "@mnjsplatform/components/lib/common/ComplexParam";
import DailyChartGrid from "../Common/DailyChartGrid";
import i18next from "i18next";
import GridView from "@mnjsplatform/components/lib/common/GridView/GridView";
import ActionLink from "@mnjsplatform/components/lib/common/ActionLink";
import AuthProvider from "@mnjsplatform/data/lib/security/authProvider";
import pathJoin from "@mnjsplatform/data/lib/utils/pathJoin";
import $ from "jquery";
import WorkScheduleCreatePopup from "./WorkScheduleCreatePopup";
import RequestForm from "./RequestForm";
import TemplateForm from "./TemplateForm";

class WorkSchedule extends Component {
    constructor() {
        super();
        this.state = {
            readOnly: false,
            showCreateForm: false,
            showEditForm: false,
            requestType: '',
            showPrintForm: false
        }
    }

    componentDidMount() {
        this.initialize();
    }

    async initialize() {
        await this.props.dispatch(this.props.monthList.reset());
        await this.props.dispatch(this.props.yearList.reset());

        await this.props.dispatch(this.props.monthList.execute({}, {withParams: true, withStyle: true}));
        await this.props.dispatch(this.props.yearList.execute(this.props.monthListParams.getRow(0), {withStyle: true}));
        await this.props.dispatch(this.props.requestList.execute());
    }

    applyParamsToYear = () => {
        this.props.dispatch(this.props.yearList.applyParams(this.props.monthListParams));
    }

    renderParams = (h) => {
        return (<div className="row">
            <div className="col-md-1 text-right">
                {/*График работы:*/}
                {h.lbl("TypeTabCalView")}
            </div>
            <div className="col-md-5">
                {h.ed("TypeTabCalView")}
            </div>

            <div className="col-md-1 text-right">
                {/*Год:*/}
                {h.lbl("NumYear")}
            </div>
            <div className="col-md-1">
                {h.ed("NumYear")}
            </div>
            <div className="col-md-1 text-right">
                {/*Месяц:*/}
                {h.lbl("MonthView")}
            </div>
            <div className="col-md-2">
                {h.ed("MonthView")}
            </div>
        </div>);
    };

    render() {
        if (!this.props.monthList.isInitialized)
            return null;
        let monthChartTitle = <></>;
        let printMonthTitle = '';
        let yearChartTitle = <></>;
        let printYearTitle = '';
        if (this.props.monthListParams.dataTable().length === 1) {
            let params = this.props.monthListParams.getRow(0);
            monthChartTitle = <> {i18next.t("Schedule")} <span
                style={{color: "red"}}>{params.TypeTabCalView}</span> {i18next.t("DailyChart_MonthSchedulePlaceholder", {
                month: params.MonthView,
                year: params.NumYear.toString()
            })}</>;
            printMonthTitle = `${i18next.t("Schedule")} ${params.TypeTabCalView} ${i18next.t("DailyChart_MonthSchedulePlaceholder", {
                month: params.MonthView,
                year: params.NumYear.toString()
            })}`;
            yearChartTitle = <> {i18next.t("Schedule")} <span
                style={{color: "red"}}>{params.TypeTabCalView}</span> {i18next.t("DailyChart_YearSchedulePlaceholder", {year: params.NumYear.toString()})}</>;
            printYearTitle = `${i18next.t("Schedule")} ${params.TypeTabCalView} ${i18next.t("DailyChart_YearSchedulePlaceholder", {year: params.NumYear.toString()})}`;
        }

        return (<>
            <PlaceholderWrapper placeholderId="20"
                                title={<><i className='fa fa-line-chart'/>{monthChartTitle}</>}
                                staticTitle={i18next.t('ScheduleForPeriod', {period: 40})}
                                showSplitterLine={false}
                                canCollapse={true}>
                <PlaceholderWrapper placeholderId="10"
                                    title={<><i className='fa fa-filter'/> {i18next.t("Filters")}</>}
                                    showSplitterLine={false}
                                    canCollapse={false}
                >
                    <ComplexParam dataItem={this.props.monthListParams}
                                  readOnly={false}
                                  showSearchBar={false}
                                  showApplyButton={false}
                                  autoApplyParams={true}
                                  rootPath="/"
                                  parentDataItem={this.props.monthList}
                                  renderParams={this.renderParams}
                                  afterApplyParams={this.applyParamsToYear}
                    />
                </PlaceholderWrapper>
                <DailyChartGrid dataItem={this.props.monthList} orientation="landscape" title={printMonthTitle}
                                margin="10mm 20px 0px 20px"
                />
            </PlaceholderWrapper>
            <PlaceholderWrapper placeholderId="30"
                                title={<><i className='fa fa-line-chart'/>{yearChartTitle}</>}
                                staticTitle={i18next.t('ScheduleForPeriod', {period: 30})}
                                showSplitterLine={false}
                                collapsed={true}
                                canCollapse={true}>
                <DailyChartGrid dataItem={this.props.yearList} orientation="landscape" title={printYearTitle}
                                margin="10mm 20px 0px 20px"
                />
            </PlaceholderWrapper>
            <PlaceholderWrapper placeholderId="40"
                                title={<><i className='fa fa-list'/>&nbsp;{i18next.t('RequestList')}</>}
                                showSplitterLine={false}
                                collapsed={false}
                                canCollapse={true}>
                <button type="button" className="mb-1 btn btn-regular -goahead" data-dismiss="modal"
                        onClick={this.createRequest}>{i18next.t('CreateStatement')}</button>
                <GridView dataItem={this.props.requestList} showHeader={false} pageSize={5} allowPagination={true}
                          readOnly={true} activePageSize={5}
                          renderRowEx={this.renderRequestRow}/>
            </PlaceholderWrapper>
            {
                this.state.showCreateForm &&
                <WorkScheduleCreatePopup onClose={this.closeCreateForm}/>
            }
            {
                this.state.showEditForm &&
                <RequestForm onClose={this.closeRequestForm} methodName={this.state.methodName} controller="DailyChart"
                             rowKey={this.state.rowKey} title={this.state.title} readOnly={this.state.readOnly}/>
            }
            {
                this.state.showPrintForm && <TemplateForm onClose={this.closeTemplateForm} rowKey={this.state.rowKey}
                                                          title={this.state.title} readOnly={true}/>
            }
        </>);
    }

    closeTemplateForm = (props) => {
        this.setState({showPrintForm: false}, async () => {
            if (props?.refresh) {
                await this.props.dispatch(this.props.requestList.refresh());
            }
        });
    }
    closeRequestForm = (props) => {
        this.setState({
            showEditForm: false,
            showPrintForm: props?.showPrintForm,
        }, async () => {
            if (props?.refresh) {
                await this.props.dispatch(this.props.requestList.refresh());
            }
        })
    }
    closeCreateForm = (props) => {
        this.setState({
            showCreateForm: false,
            showEditForm: props?.rowKey,
            methodName: props?.methodName,
            rowKey: props?.rowKey,
            title: props?.requestType,
            readOnly: false
        }, async () => {
            if (props?.refresh) {
                await this.props.dispatch(this.props.requestList.refresh());
            }
        })
    }
    createRequest = async () => {
        this.setState({showCreateForm: true});
    }
    getStatus = (row) => {
        let className = 'badge-secondary';
        switch (row.Status) {
            case 'draft': {
                className = 'badge-secondary';
                break;
            }
            case 'send': {
                className = 'badge-success';
                break;
            }
            default: {
                className = 'badge-secondary';
                break;
            }
        }
        return <span className={"badge badge-pill " + className}>{row.TitleStatus}</span>
    }
    renderRequestRow = (rowData) => {
        if (!rowData.row)
            return null;
        return (<tr key={rowData.row.AppPersIntId} style={{borderTop: 'none'}}>
            <td className="p-1">
                <ActionLink onSelect={() => this.openParamForm(rowData.row)}>{rowData.row.TitleApp}</ActionLink>
                &nbsp;
                {this.getStatus(rowData.row)}
                &nbsp;
                <ActionLink onSelect={() => this.openPrintForm(rowData.row)}>{rowData.row.TitleDoc}</ActionLink>
            </td>
        </tr>)
    }
    openParamForm = (row) => {
        this.setState({
            showEditForm: true,
            methodName: row.NameMethod,
            rowKey: this.props.requestList.getRowKey(row),
            title: row.TitleApp,
            readOnly: row.Status !== 'draft'
        });
    }
    openPrintForm = (row) => {
        if (row.IsPaper === 0) {
            this.getDocument(row)
        } else {
            this.setState({
                rowKey: this.props.requestList.getRowKey(row),
                title: row.TitleApp,
                showPrintForm: true
            });
        }
    }
    getDocument = async (row) => {
        const token = await AuthProvider.getToken();
        const downloadPath = pathJoin(window.config.apiRoot, "EDDocList", "DownloadDocument") + "?" + $.param({
            b_token: token,
            id: row.EDocIntId
        });
        window.open(downloadPath, '_blank');
    }
}

WorkSchedule.propTypes = {
    dispatch: PropTypes.func.isRequired,
    monthList: PropTypes.object,
    monthListParams: PropTypes.object,
    yearList: PropTypes.object,
    requestList: PropTypes.object
};

WorkSchedule.defaultProps = {};

function mapStateToProps(state, ownProps) {
    return {
        monthList: state.dailyChartState.WorkSchedule_MonthList,
        monthListParams: state.dailyChartState.WorkSchedule_MonthListParams,
        yearList: state.dailyChartState.WorkSchedule_YearList,
        requestList: state.dailyChartState.AppPers_ListForPO
    }
}

export default connect(mapStateToProps)(WorkSchedule)